import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    timeWindows: translate({ id: 'orders.edit.field.timeWindows' }),
    invalidTimeWindows: translate({ id: 'orders.edit.validation.timeWindow.startEndError' }),
  }))

  return api
}

export type Texts = ReturnType<typeof useTexts>
